import React from 'react';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer id="contact" className="bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-5 gap-8 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center mb-6">
              <img 
                src="/white-logo.gif" 
                alt="Global Trademark USA Logo" 
                style={{ height: '65px', width: 'auto', maxWidth: '100%' }}
              />
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed max-w-md">
              Protecting your brand identity with expert trademark registration services, copyright services, and company formation across the USA.
            </p>
            <Button className="bg-gradient-to-r from-emerald-600 to-emerald-700 hover:from-emerald-700 hover:to-emerald-800">
              Get Started Today
            </Button>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-300 hover:text-emerald-400 transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-emerald-400 transition-colors">About</Link></li>
              <li><Link to="/#pricing" className="text-gray-300 hover:text-emerald-400 transition-colors">Pricing</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-emerald-400 transition-colors">Contact</Link></li>
              <li><a href="#faq" className="text-gray-300 hover:text-emerald-400 transition-colors">FAQ</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Services</h4>
            <ul className="space-y-2">
              <li><Link to="/trademark-registration" className="text-gray-300 hover:text-emerald-400 transition-colors">Trademark Registration</Link></li>
              <li><Link to="/copyright-registration" className="text-gray-300 hover:text-emerald-400 transition-colors">Copyright Registration</Link></li>
              <li><Link to="/company-formation" className="text-gray-300 hover:text-emerald-400 transition-colors">Company Formation</Link></li>
              <li><Link to="/trademark-search" className="text-gray-300 hover:text-emerald-400 transition-colors">Trademark Search</Link></li>
              <li><Link to="/amazon-brand-registry" className="text-gray-300 hover:text-emerald-400 transition-colors">Amazon Registry</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-0.5" />
                <div>
                  <a href="tel:+18889099199" className="text-gray-300 hover:text-emerald-400 transition-colors">
                    +1 (888) 909 9199
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-0.5" />
                <div>
                  <a href="mailto:info@globaltrademarkusa.com" className="text-gray-300 hover:text-emerald-400 transition-colors break-all">
                    info@globaltrademarkusa.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-gray-300">
                    714 E Carson St<br />
                    Carson, CA 90745<br />
                    United States
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-300 text-sm">
              © 2025 - Global Trademark USA. All rights reserved
            </p>
            <div className="flex gap-6 items-center">
              <Link to="/privacy-policy" className="text-gray-300 hover:text-emerald-400 transition-colors text-sm">Privacy Policy</Link>
              <span className="text-gray-400">|</span>
              <Link to="/terms-conditions" className="text-gray-300 hover:text-emerald-400 transition-colors text-sm">Terms & Conditions</Link>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gray-950 py-4">
        <div className="container mx-auto px-4">
          <p className="text-center text-gray-500 text-sm">
            We use cookies and similar technologies that are necessary to operate the website. By continuing to use our website, you consent to our use of cookies.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;